<ng-container *transloco="let t">
    <div class="relative flex flex-col md:w-140 -m-6 pr-0 overflow-y-auto overflow-x-hidden" style="max-height: 90vh;">

        <!-- Dismiss button -->
        <div class="flex flex-row justify-between bg-gray-100 dark:bg-gray-700 p-4 border-b items-center">
            <!-- Title -->
            <div class="text-2xl leading-6 font-medium flex items-center">
                <mat-icon [svgIcon]="'heroicons_outline:user-add'" class="text-secondary icon-size-7 mr-2"></mat-icon>
                {{(!!existingArtist ? 'edit-artist' : 'new-artist') | transloco}}
            </div>

            <div class="">
                <button [matDialogClose]="undefined" mat-icon-button>
                    <mat-icon [svgIcon]="'heroicons_outline:x-mark'" class="text-secondary"></mat-icon>
                </button>
            </div>
        </div>

        <!-- Content -->
        <div class="flex flex-col sm:flex-row items-start p-8 pb-6 sm:pb-8">

            <div class="flex flex-col items-start mt-4 sm:mt-0 text-left w-full">

                <form (ngSubmit)="onSubmit()" [formGroup]="form" class="grid grid-cols-12 items-start w-full"
                    id="artistForm">

                    <mat-form-field class="col-span-12">
                        <mat-label>{{'artist-name' | transloco}}</mat-label>
                        <input [formControlName]="'title'" autocomplete="off" matInput required
                            [disabled]="!!existingArtist">
                    </mat-form-field>

                    <mat-form-field *ngIf="thisUser.role === 'label'" class="col-span-12 mt-2">
                        <mat-label>E-Mail</mat-label>
                        <mat-icon [svgIcon]="'heroicons_solid:at-symbol'" class="icon-size-5" matPrefix></mat-icon>
                        <input [formControlName]="'email'" autocomplete="off" matInput>
                    </mat-form-field>

                    <fuse-alert class="my-2 col-span-12" [appearance]="'fill'" [showIcon]="true" type="info">
                        {{'artist-id-call-to-cation' | transloco}}
                    </fuse-alert>

                    <!-- <div class="col-span-12 my-2" [innerHTML]="'artist-id-call-to-cation' | transloco">To ensure that
                        your release will be assigned to the correct artist by
                        the store, please add the artist ids for Spotify and iTunes/Apple Music.<br><br>You can either
                        paste the url of the artist page or search by name.</div> -->

                    <mat-form-field class="col-span-12 mt-2">
                        <mat-label>Spotify ID</mat-label>
                        <mat-icon [svgIcon]="'heroicons_solid:magnifying-glass'" class="icon-size-5" matPrefix></mat-icon>
                        <input [formControlName]="'spotify'" matInput [placeholder]="'search-or-paste-link' | transloco"
                            [matAutocomplete]="spotifyAutoComplete"
                            [matAutocompleteDisabled]="form.get('spotify').valid" (focus)="onSpotifySearchFocused()">
                        <mat-autocomplete panelClass="w-full" #spotifyAutoComplete="matAutocomplete"
                            (optionSelected)="selectArtist($event)">
                            <mat-option *ngFor="let artist of spotifyArtists" [value]="artist.spotifyId"
                                class="mat-option-full-width flex items-center">
                                <div class="h-12 mb-1 grid grid-cols-12 items-center justify-between w-full">
                                    <div class="col-span-8 inline-flex items-center">
                                        <img *ngIf="artist.imageUrl" [src]="artist.imageUrl"
                                            class="w-12 h-12 rounded-full mr-2">
                                        <span *ngIf="!artist.imageUrl" class="w-12 h-12 mr-2"></span>
                                        <span class="text-lg">{{artist.title}}</span>
                                    </div>
                                    <a *ngIf="artist.spotifyId"
                                        (click)="openSpotifyArtistPage($event, artist.spotifyId)"
                                        class="ml-2 col-span-4 inline-flex items-center justify-self-end hover:underline hover:text-primary-700">
                                        <mat-icon [svgIcon]="'heroicons_solid:arrow-top-right-on-square'"
                                            class="icon-size-5"></mat-icon>Artist Page
                                    </a>
                                </div>

                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>

                    <mat-form-field class="col-span-12 mt-2">
                        <mat-label>Apple Music ID</mat-label>
                        <mat-icon [svgIcon]="'heroicons_solid:magnifying-glass'" class="icon-size-5" matPrefix></mat-icon>
                        <input [formControlName]="'apple'" autocomplete="off" matInput
                            [placeholder]="'search-or-paste-link' | transloco" [matAutocomplete]="appleAutoComplete"
                            [matAutocompleteDisabled]="form.get('apple').valid" (focus)="onAppleSearchFocused()">
                        <mat-autocomplete panelClass="w-full" #appleAutoComplete="matAutocomplete"
                            (optionSelected)="selectArtist($event)">
                            <mat-option *ngFor="let artist of appleArtists" [value]="artist.appleId"
                                class="mat-option-full-width flex items-center w-full">
                                <div class="h-12 mb-1 grid grid-cols-12 items-center w-full">
                                    <div class="col-span-8 inline-flex items-center">
                                        <img *ngIf="artist.imageUrl" [src]="artist.imageUrl"
                                            class="w-12 h-12 rounded-full mr-2">
                                        <span *ngIf="!artist.imageUrl" class="w-12 h-12 mr-2"></span>
                                        <span class="text-lg">{{artist.title}}</span>
                                    </div>
                                    <a *ngIf="artist.appleId" (click)="openAppleArtistPage($event, artist.appleId)"
                                        class="ml-2 col-span-4 inline-flex items-center justify-self-end hover:underline hover:text-primary-700">
                                        <mat-icon [svgIcon]="'heroicons_solid:arrow-top-right-on-square'"
                                            class="icon-size-5"></mat-icon>Artist Page
                                    </a>
                                </div>

                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>

                    <mat-accordion class="accordion-shadowless" id="track-summary-accordion" class="col-span-12 mb-4 mt-2" style="filter: drop-shadow(0px 0px 0.5px #888);">
                        <mat-expansion-panel [expanded]="false" class="track-summary-panel rounded-md">
                            <mat-expansion-panel-header class="h-12 px-6 py-4">
                                <mat-panel-title class="justify-start">
                                    <mat-icon [svgIcon]="'heroicons_solid:arrow-long-right'"
                                        class="mr-2 icon-size-5"></mat-icon>
                                    {{"other-artist-ids-title" | transloco}}
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div class="grid grid-cols-12 gap-1 mt-2">
                                <mat-form-field class="col-span-12">
                                    <mat-label>ISNI <form-field-tooltip tooltipTitleKey="isni-tooltip-title"
                                        tooltipKey="isni-tooltip"></form-field-tooltip></mat-label>
                                    <mat-icon [svgIcon]="'heroicons_solid:identification'" class="icon-size-5"
                                        matPrefix></mat-icon>
                                    <input [formControlName]="'isni'" autocomplete="off" matInput>
                                    <mat-error *ngIf="form.get('isni').hasError('invalidISNI')">{{'isni-not-valid' |
                                        transloco}}</mat-error>
                                </mat-form-field>
                                <mat-form-field class="col-span-12">
                                    <mat-label>Amazon ID / ASIN <form-field-tooltip tooltipTitleKey="amazon-id-tooltip-title"
                                        tooltipKey="amazon-id-tooltip"></form-field-tooltip></mat-label>
                                    <mat-icon [svgIcon]="'heroicons_solid:identification'" class="icon-size-5"
                                        matPrefix></mat-icon>
                                    <input [formControlName]="'amazon'" autocomplete="off" matInput>
                                    <mat-error *ngIf="form.get('amazon').hasError('invalidAmazon')">{{'amazon-id-not-valid' |
                                        transloco}}</mat-error>
                                </mat-form-field><mat-form-field class="col-span-12">
                                    <mat-label>Meta ID</mat-label>
                                    <mat-icon [svgIcon]="'heroicons_solid:identification'" class="icon-size-5"
                                        matPrefix></mat-icon>
                                    <input [formControlName]="'meta'" autocomplete="off" matInput>
                                    <mat-error *ngIf="form.get('meta').hasError('invalidMeta')">{{'meta-id-not-valid' |
                                        transloco}}</mat-error>
                                </mat-form-field>
                                <mat-form-field class="col-span-12">
                                    <mat-label>SoundCloud ID</mat-label>
                                    <mat-icon [svgIcon]="'heroicons_solid:identification'" class="icon-size-5"
                                        matPrefix></mat-icon>
                                    <input [formControlName]="'soundcloud'" autocomplete="off" matInput>
                                    <mat-error *ngIf="form.get('soundcloud').hasError('invalidSoundCloud')">{{'soundcloud-id-not-valid' |
                                        transloco}}</mat-error>
                                </mat-form-field>
                            </div>
                        </mat-expansion-panel>
                    </mat-accordion>

                    <mat-checkbox (change)="onCheckboxChange()" [formControlName]="'newArtist'" class="mt-2 col-span-12"
                        color="primary">{{'new-artist-disclaimer' | transloco}}</mat-checkbox>

                </form>
            </div>

        </div>

        <fuse-alert class="mb-4 mt-4 w-full px-6" *ngIf="errorKey" [appearance]="'outline'" [showIcon]="false"
            [type]="'error'">
            {{ t(errorKey) }}
        </fuse-alert>

        <!-- Actions -->
        <div [matTooltip]="thisUser.permissions.demoAccount ? 'Not available in demo.' : ''"
            class="flex items-center justify-center sm:justify-end px-6 py-4 space-x-3 bg-gray-50 dark:bg-black dark:bg-opacity-10">

            <!-- Confirm -->
            <button [color]="'primary'" form="artistForm" mat-flat-button
                [disabled]="form.invalid || form.pending || !form.dirty || thisUser.permissions.demoAccount"
                type="submit">
                {{'save-artist-button' | transloco}}
            </button>

        </div>

    </div>
</ng-container>
